<template>
  <div class="header-menu">
    <MainMenu></MainMenu>
  </div>
   
</template>

<script>
import MainMenu from '@/components/header/MainMenu'

export default {
  name: 'HeaderMenu',
  components: {
    MainMenu
  },
  data () {
    return {
      username: 'gisleung',
      editTool: false
    }
  },
  methods: {
    signout () {

    }
  }
}
</script>

<style lang="less" scoped>
.header-menu{
  width: 100%;
  height: 46px;
  background-color:  #8cd7ff;
}


</style>
